var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.List),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.clickListNews(item)}}},[(index < 7)?_c('span',[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4d61d28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/assembly/DmkyList.vue
// module id = null
// module chunks = 